

import Underline from '@tiptap/extension-underline'
import { UnderlineActionButton } from '@/tiptap/extensions/components/ActionButton'

export default Underline.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      button: ({ editor, t }) => ({
        component: UnderlineActionButton,
        componentProps: {
          editor,
          t,
        },
      }),
    }
  },
})